<template>
    <v-card class="panelBlock mt-4 prospect-poll" v-if="prospectsList && prospectsList.prospects && prospectsList.prospects.length>0">
        <v-flex tag="h2">{{communityCommonConstant.prospects.TITLE}}</v-flex>
        <v-flex>
            <v-list
                class="recom_member"
                v-for="(prospect, index) in prospectsList.prospects"
                :key="index"
                xs12
                :class="{'recom_member__border-list':index===prospectsList.prospects.length-1}">
                <v-flex pb-3>
                    <v-list-tile avatar xs4 :id="`prospect_unitTest_${index}`">
                        <v-list-tile-avatar size="60">
                            <v-img :src="prospect.profileImageUrl" :onerror="imageErrorFallback(prospect.fallbackProfileImageUrl)">
                            </v-img>
                        </v-list-tile-avatar>
                        <v-flex ml-3 xs8 height="60">
                            <v-list-tile-content>
                                <v-list-tile-title :data-qe-id="`prospect_${index}_name`">
                                    {{prospect.firstName}} {{prospect.lastName}}
                                </v-list-tile-title>
                                <v-list-tile-action>
                                    <v-flex class="like_btns">
                                        <span class="unlike_btn" :class ="{'active': !prospectsList.canVote}"
                                              role="button"
                                              :data-qe-id="`prospect_${index}_vote-down_link`"
                                              @click="createVotes(prospect.id,false,prospect.userHasVoted)">
                                            <i class="far fa-thumbs-down" v-if="!(prospect.userHasVoted===0 && prospectsList.canVote)"></i>
                                            <i class="fas fa-thumbs-down" v-if="prospect.userHasVoted===0 && prospectsList.canVote"></i>
                                            <strong v-if="prospect.downCount!=null">{{prospect.downCount}}</strong>
                                        </span>
                                        <em>|</em>
                                        <span class="like_btn" :class ="{'active': !prospectsList.canVote}"
                                              role="button"
                                              :data-qe-id="`prospect_${index}_vote-up_link`"
                                              @click="createVotes(prospect.id,true,prospect.userHasVoted)">
                                            <strong v-if="prospect.upCount!=null">{{prospect.upCount}}</strong>
                                            <i class="far fa-thumbs-up" v-if="!(prospect.userHasVoted===1 && prospectsList.canVote)"></i>
                                            <i class="fas fa-thumbs-up" v-if="(prospect.userHasVoted===1 && prospectsList.canVote)"></i>
                                        </span>
                                    </v-flex>
                                </v-list-tile-action>
                            </v-list-tile-content>
                        </v-flex>
                    </v-list-tile>
                </v-flex>
                <v-divider v-if="index!==prospectsList.prospects.length-1" class="recom_member__border-divider"></v-divider>
            </v-list>
            <v-divider v-if="this.prospectsList && this.prospectsList.prospects && this.prospectsList.prospects[0].upCount!=null && this.prospectsList.prospects[0].downCount!=null" class="recom_member__border-divider"></v-divider>
            <v-flex v-if="this.prospectsList && this.prospectsList.prospects && this.prospectsList.prospects[0].upCount!=null && this.prospectsList.prospects[0].downCount!=null" class="recom_member__results text-xs-right">
                <v-btn
                    flat
                    small
                    :loading="prospectDownloadInProgress"
                    class="recom_member__download-font text-xs-right"
                    data-qe-id="prospect_result-download_btn"
                    @click="reultDownload()"> {{communityCommonConstant.prospects.VIEW_RESULTS}}
                </v-btn>
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { communityCommonConstant } from "../communityCommon.constant";
    import { imageErrorFallback } from "@/common/utils/utils";

    export default {
        name: "prospectsPoll",
        created() {
            this.getProspectsList();
            this.$watch(
                () => this.$store.getters[storeGetters.communityIdPromise],
                () => {
                    this.getProspectsList();
                },
            );
        },
        components: {},
        data: () => {
            return {
                communityCommonConstant,
                votes: {
                    prospectId: null,
                    vote: null,
                    index: 0,
                },
                prospectsFields: communityCommonConstant.prospects.PROSPECTS_FIELDS,
            };
        },
        methods: {
            ...mapActions({
                getProspectsList: `chapter/${storeAction.getProspectsList}`,
                createVote: `chapter/${storeAction.createVote}`,
                reultDownload: `chapter/${storeAction.ProspectsResultsDownload}`,
            }),
            imageErrorFallback,
            createVotes(prospectId, vote, value) {
                if ((value === 1 && vote === true) || !this.prospectsList.canVote) {
                    return;
                }

                if ((value === 0 && vote === false) || !this.prospectsList.canVote) {
                    return;
                }
                this.votes.prospectId = prospectId;
                this.votes.vote = vote;
                this.createVote(this.votes).then(() => {
                    this.getProspectsList();
                });
            },
        },
        computed: {
            ...mapGetters({
                prospectsList: `chapter/${storeGetters.prospectsList}`,
                voted: `chapter/${storeGetters.voted}`,
                prospectDownloadInProgress: `chapter/${storeGetters.prospectDownloadInProgress}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .opac {
        opacity: 1;
    }

    .recom_member {
        height: auto;
        padding: 15px 5px 5px 5px;
        align-items: stretch;

        &__results {
            padding: 5px;
            padding-right: 0px;
            margin-right: -4px;
        }

        &__download-font {
            font-size: 14px;
            color: $ypo-dark-gray;
            font-weight: bold;
        }

        &__border-list {
            border-radius: 5px;
        }

        &__border-divider {
            border-color: $ypo-prospect-list-border;
            margin-left: 10px;
            margin-right: 10px;
        }

        .v-list__tile__title {
            color: $ypo-gray-text;
            font-size: 16px;
            font-weight: 500;
        }

        .v-list__tile__sub-title {
            font-size: 12px;
            color: $ypo-gray;
        }

        .desc {
            font-size: 12px;
            color: $ypo-gray;
            display: block;
            margin-top: 10px;
        }

        .like_btns {
            em {
                color: $ypo-medium-gray;
                font-style: normal;
                margin: 0px 3px;
            }

            strong {
                font-size: 16px;
                font-weight: 400;
                margin: 0 3px;
            }

            .unlike_btn {
                color: $ypo-dark-background-gray;
                font-size: 22px;

                i {
                    transform: scaleX(-1);
                    position: relative;
                    top: 5px;
                }
            }

            .like_btn {
                color: $ypo-cta;
                font-size: 22px;
            }

            .active {
                cursor: default;

                i {
                    font-weight: 600;
                }
            }
        }
    }
</style>
